"use strict";

$(function () {
    var $body = $("body");
    var edge = "documentMode" in document || /Edge/.test(navigator.userAgent);
    // Merci Edge
    if (edge) {
        window.addEventListener("dragover", function (e) {
            e.preventDefault();
        }, false);
        $("#boxDropZone").on("drop", function (e) {
            var $me = $(this);
            var $input = $me.find("input[type=file]");
            var input = $input.get(0);
            var files = e.originalEvent.dataTransfer.files;
            input.__files = files;
            $input.trigger("file:input");
        });
    }
    $body.on("dragover", function (e) {
        if (!$(e.target).closest("#boxDropZone").length && !$(e.target).is("#boxDropZone")) {
            $("#boxDropZone").addClass("d-none");
        }
    }).on("mouseover", function (e) {
        $("#boxDropZone").addClass("d-none");
    });
    $("#dropZone").on("dragover", function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        $("#boxDropZone").removeClass("d-none");
    });
    $("#boxDropZone input[type=file]").on("drop change file:input", function () {
        var $form = $(this.form),
            $modal = $("#modalDragAndDrop"),
            $typeId = $("#typeId"),
            $affaireId = $("#affaireId"),
            $bonCommandeId = $("#bonCommandeId"),
            $selectAffaire = $("#selectAffaire"),
            valAffaireId = $affaireId.val();
        if ($modal.is(":visible")) {
            return;
        }
        // Fonction d'ouverture de la modale
        var initModal = function initModal() {
            $modal.find(".btn-success").off().on("click", function () {
                var _this = this;
                $typeId.val($("#selectType").val());
                $bonCommandeId.val($("#selectBc").val());
                if ($selectAffaire.get(0)) {
                    $affaireId.val($selectAffaire.val());
                }
                if (!$typeId.val()) {
                    alert("Veuillez sélectionner un type de fichier");
                    return false;
                }
                if (!$affaireId.val()) {
                    alert("Veuillez sélectionner une affaire");
                    return false;
                }
                // On vérifie que le fichier va pas être remplacé
                confirmItWillReplace($form, function () {
                    // Désactivation du bouton
                    var $button = $(_this);
                    $button.attr("disabled", "disabled");
                    // Barre de progression
                    var $progress = $modal.find(".progress").removeClass("d-none");
                    var $progressBar = $progress.find(".progress-bar");
                    $progressBar.attr("aria-valuenow", 0);
                    $progressBar.width(0);
                    // Submit
                    var fd = new FormData($form.get(0));
                    if (edge) {
                        $form.find("input[type='file']").each(function () {
                            var input = this;
                            // Propriété créée pour Edge
                            var files = this["__files"];
                            if (files && files.length) {
                                $.each($.makeArray(files), function () {
                                    fd.append(input.name, this);
                                });
                            }
                        });
                    }
                    $.ajax({
                        url: $form.attr("action"),
                        data: fd,
                        processData: false,
                        contentType: false,
                        type: $form.attr("method"),
                        xhr: function xhr() {
                            var xhr = $.ajaxSettings.xhr();
                            // Mise à jour de la barre de progression
                            if (xhr.upload) {
                                xhr.upload.addEventListener("progress", function (e) {
                                    if (!e.lengthComputable) {
                                        return;
                                    }
                                    var pct = e.loaded * 100 / e.total;
                                    $progressBar.width(pct + "%");
                                }, false);
                            }
                            return xhr;
                        },
                        success: function success() {
                            document.location.reload();
                        }
                    });
                });
            });
            $modal.modal("show");
        };
        // Fonction de chargement du select de bons de commande
        var loadSelect = function loadSelect($select, affaireId) {
            $.getJSON($select.data("url") + ("/" + affaireId), function (data) {
                $select.html("<option value=''> &ndash; </option>");
                $.each(data, function (i, d) {
                    return $select.append("<option value=\"" + d.value + "\">" + d.text + "</option>");
                });
            });
        };
        // Ouverture de la modale
        initModal();
        // Si on est sur une affaire
        if (valAffaireId) {
            loadSelect($("#selectBc"), valAffaireId);
            return;
        }
        // Sinon initialisation de la recherche d'affaire
        var $search = $("#selectAffaire");
        $search.on("select2:select", function (select) {
            var event = select;
            var selected = event.params.data.id;
            loadSelect($("#selectBc"), selected);
        });
        $search.select2({
            placeholder: "Veuillez choisir une affaire",
            width: "100%",
            templateResult: function templateResult(selected) {
                var affaire = selected;
                if (!affaire.id) {
                    return "";
                }
                return $("<span><strong>" + affaire.codeAffaire + "</strong>  " + affaire.libelle + "\n                                    <br />" + affaire.codeInsee + " " + affaire.communeTravaux + "</span>");
            },
            ajax: {
                url: $search.data("url"),
                dataType: "json",
                processResults: function processResults(data) {
                    return {
                        results: $.map(data.results, function (d) {
                            d.text = d.codeAffaire;
                            return d;
                        })
                    };
                }
            }
        });
    });
    var confirmItWillReplace = function confirmItWillReplace($form, callback) {
        var url = $form.data("confirm-url");
        var form = $form[0];
        $.ajax({
            url: url,
            type: "get",
            data: {
                affaireId: form.elements["AffaireId"].value,
                bonCommandeId: form.elements["BonCommandeId"].value,
                fileType: form.elements["TypeId"].value
            },
            success: function success(itWillReplace) {
                if (!itWillReplace || confirm("Le fichier déposé annule et remplace un fichier existant parce qu'il est unique pour le bon de commande sélectionné, souhaitez-vous continuer ?")) {
                    callback();
                }
            }
        });
    };
    $body.on("click", ".confirm-replace-doc", function (e) {
        e.preventDefault();
        var $btn = $(this);
        var $form = $btn.parents("form");
        confirmItWillReplace($form, function () {
            return $form.submit();
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Affaire/upload.ts
// module id = 597
// module chunks = 0